<template>
  <Input v-model="local" type="number" @input="emitUpdate" />
</template>

<script>
import { Input } from "@/shared/ui/input";

export default {
  components: { Input },
  props: ["item"],
  data() {
    return {
      local: JSON.stringify(this.item.value ?? {}, null, 2),
    };
  },
  methods: {
    emitUpdate() {
      this.$emit("update", this.item.key, Number(this.local));
    },
  },
};
</script>
